<template>
  <div class="invoice">
    isSdkReady：{{ isSdkReady }}
    <van-field
      v-model="orderNo"
      type="digit"
      clearable
      placeholder="请输入订单号/扫描小票上方条形码"
    >
      <template #button>
        <div class="scan" @click="handleScanClick"></div>
      </template>
    </van-field>
    <div class="action-wrapper">
      <invoice-button
        :disabled="false"
        text="postMessage"
        @handleButtonClick="handleMakeOuInvoice"
      ></invoice-button>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import invoiceButton from "@/components/invoiceButton";
export default {
  name: "Invoice",
  components: {
    invoiceButton,
  },
  data: () => {
    return {
      isSdkReady: false,
      orderNo: null,
    };
  },
  mounted() {
    wx.ready(() => {
      wx.hideOptionMenu();
      this.isSdkReady = true;
      this.orderNo = this.$route.query.orderNo;
    });
  },
  methods: {
    handleScanClick() {
      console.log(123);
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          console.log(res);
        },
      });
    },
    handleMakeOuInvoice() {
      // window.sessionStorage.setItem('orderNo',this.orderNo)
      // this.$router.push({path: '/receipt', query:{orderNo: this.orderNo}})
      // console.log(123)
      uni.postMessage({
        data: {
          action: "message",
        },
      });
      uni.getEnv(function (res) {
        console.log("当前环境：" + JSON.stringify(res));
      });
    },
  },
};
</script>

<style scoped lang="scss">
.invoice {
  background: #f5f5f5;
  height: 100%;
  padding: 28px 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  box-sizing: border-box;
  position: relative;
  .van-cell {
    padding: 32px 28px;
    line-height: 44px;
    border-radius: 16px;
    .van-field__button {
      display: flex;
      justify-content: center;
      align-items: center;

      .scan {
        width: 44px;
        height: 44px;
        font-size: 0;
        background: url(../../assets/invoice/scan.png);
        background-size: 100% 100%;
      }
    }
  }
  .action-wrapper {
    background: white;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 20px 64px 40px 64px;
    box-shadow: 0px -2px 20px 0px rgba(17, 17, 17, 0.04);
    backdrop-filter: blur(0px);
  }
}
</style>
